import React from "react";
import { Helmet } from "react-helmet-async";

import "./App.css";
import "../../style/global.css";
import "../../style/imageTextSection.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ContactForm from "../../components/Contact/ContactForm";
import HeroSection from "../../components/HeroSection/Hero";

import Machine4 from "../../assets/images/machine4.png";
import FC3 from "../../assets/images/FC3.jpg";
import BB2 from "../../assets/images/BB2.jpg";

import HeroImage from "../../assets/images/hero-fruit.jpg";

function App() {
  return (
    <div>
      <Helmet>
        <title>Home</title>
      </Helmet>

      <Header></Header>

      <HeroSection
        backgroundImage={HeroImage}
        title="Welcome to Blendz"
        subtitle="Premium slushy solutions"
        dividerPath="M0,320L48,314.7C96,309,192,299,288,266.7C384,235,480,181,576,160C672,139,768,149,864,170.7C960,192,1056,224,1152,213.3C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        dividerColour="var(--shading-colour)"
      />

      <div
        className="ImgTextSection"
        style={{ backgroundColor: "var(--shading-colour)" }}
      >
        <div className="SectionLeft">
          <div className="ImageContainer">
            <img
              src={FC3}
              alt="Blendz slushy machine"
              className="ContentImages"
            />
          </div>
        </div>
        <div className="SectionRight">
          <div className="TextContainer">
            <h2>
              Cocktail concentrates, slushy concentrates and spare parts
            </h2>
            <p>
              Welcome to Blendz, an authorized distributor of Elmeco slushy
              machines in New Zealand and the South Pacific. Specializing in
              innovative beverage technology, we deliver high-performance
              commercial slushy machines, expertly crafted by Elmeco Italy, to
              businesses seeking reliable and refreshing drink solutions.
            </p>
          </div>
        </div>
      </div>

      <div className="ImgTextSection">
        <div className="SectionLeft">
          <div className="TextContainer">
            <h2>
              Your Complete Slushy Machine Partner: Sales, Rentals, and Support
            </h2>
            <p>
              Blendz is your one-stop partner for all slushy machine needs,
              offering comprehensive solutions to streamline your operations.
              From sales and rentals of high-performance Elmeco slushy machines
              to certified servicing and repairs by local technicians, we ensure
              minimal downtime and maximum efficiency. Our premium slushy
              concentrates, accessories, and spare parts guarantee consistent
              quality, while our expert team provides hassle-free support at
              every stage - from setup to ongoing maintenance.
            </p>
          </div>
        </div>
        <div className="SectionRight">
          <div className="ImageContainer">
            <img
              src={BB2}
              alt="Blendz slushy machine"
              className="ContentImages"
            />
          </div>
        </div>
      </div>

      <div
        className="ImgTextSection"
        style={{ backgroundColor: "var(--shading-colour)" }}
      >
        <div className="SectionLeft">
          <div className="ImageContainer">
            <img
              src={Machine4}
              alt="Blendz slushy machine"
              className="ContentImages"
              style={{ transform: "scaleX(1)" }}
            />
          </div>
        </div>
        <div className="SectionRight">
          <div className="TextContainer">
            <h2>Innovating Refreshment with '2 Mix It' Technology</h2>
            <p>
              Pioneered by Blendz, our exclusive '2 Mix It' system
              revolutionizes beverage dispensing. This cutting-edge innovation
              allows you to blend unique flavors and textures, creating
              signature drinks that captivate customers and boost profitability.
            </p>
          </div>
        </div>
      </div>

      <div className="HomeContactContainer">
        <div className="HomeContactTitle">
          <h2>Get in touch</h2>
          <p>
            Have any questions for us? Let us know, we'll get back to you ASAP
          </p>
        </div>

        <ContactForm />
      </div>

      <footer>
        <Footer></Footer>
      </footer>
    </div>
  );
}

export default App;
